module.exports = __webpack_public_path__ + "img/associate_member_nskiv.d4a57ac.svg";